<template>
  <div class="modal error-modal">
    <div class="overlay" @click="$parent.closeErrorModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeErrorModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">ERROR</div>
                <div class="error-message desc dark">
                  {{ $parent.errorModalMessage }}
                </div>
                <button class="button" @click="$parent.closeErrorModal">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorModal",
};
</script>

<style scoped lang="scss">
.error-modal {
  .wrapper {
    max-width: 685px;
  }

  .container {
    padding: 52px 16px 0;
    max-height: 100vh;
    overflow: auto;
  }

  .form-fields-wrapper {
    max-width: 460px;
    margin: 0 auto;
    padding-bottom: 50px;
    text-align: center;
    font-family: "Inter", sans-serif;
    color: #312727;
  }

  .error-message {
    margin-top: 16px;
  }

  .button {
    margin: 24px auto 0;
    max-width: 276px;
    display: table;
    width: 100%;
    text-transform: uppercase;
    font-size: 16px;
  }
}

@media screen and (max-width: 768px) {
  .error-modal .container {
    padding: 32px 16px;
  }
}
</style>
